import config from './config';
import layers from './layers';
import paymentDetails from './paymentDetails';
import paymentUserData from './paymentUserData';
import widgetData from './widgetData';
import modal from './modal';
import ntbFlow from './ntbFlow';
import ntbPayment from './ntbPayment';
import registrationUserData from './registrationUserData';

export default {
  config,
  paymentDetails,
  paymentUserData,
  layers,
  widgetData,
  modal,
  ntbFlow,
  ntbPayment,
  registrationUserData,
};



// WEBPACK FOOTER //
// ./components/transaction/src/reducer/index.js